export default "__VITE_ASSET__CE1pWB6C__"